type Args = { accountId: number };

class FetchAccount {
	readonly accountId: number;

	constructor(args: Args) {
		this.accountId = args.accountId;

		Object.freeze(this);
	}
}

export default FetchAccount;
